import React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './PostCTA.module.scss';

const PostCTA = ({ templateId }) => {
  return (
    <div className={styles.createNewProject}>
      <Link to={`https://beta.spreadsheep.io/#/create/${templateId}`}>
        <FontAwesomeIcon icon={['fas', 'plus']} />
            &nbsp; Créer un projet à partir de ce modèle
      </Link>
    </div>
  );
};

export default PostCTA;
